import Loancalculation from "../../../jsx/components/Dashboard/LoanCalculation/loancalculation";

const LoanCalculationWrapper = () => {
  return <Loancalculation />;
};

export default constore(LoanCalculationWrapper);
